import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Text } from '@contrast-security-inc/design-system-typography'
import React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { FullscreenModal } from '@contrast-security-inc/design-system-popovers'
import { SCMOption } from './scm-option'
import { useTeamserverUrl } from '../../components/teamserver-url/api/use-teamserver-url'
import { useSirOnboardingSettings } from '../../api/queries/platform-service/platform-service'
import { toast } from '@contrast-security-inc/design-system-alerts'
import { useIntl } from 'react-intl'
import { useCurrentOrganization, useSplitClient } from 'contrastBase/state'
import {
  SCMType,
  postOnboardingService
} from '../../api/queries/onboarding-service/onboarding-service'

const headerStyles = css`
  background-color: ${theme.color.white};
  padding: 24px 41px 33px;
`
const bodyStyles = css`
  display: flex;
  align-self: center;
  flex-direction: column;
`

export const SCMOptionsPage = () => {
  const { formatMessage } = useIntl()
  const { currentOrganization } = useCurrentOrganization()
  const organizationUuid = currentOrganization?.organizationUuid ?? ''
  const { teamserverUrl } = useTeamserverUrl()
  const { isSplitTreatmentOn } = useSplitClient()
  const showGitlab = isSplitTreatmentOn('PROD-443_sir_gitlab')
  const showBitbucket = isSplitTreatmentOn('PROD-443_sir_bitbucket')

  const { data } = useSirOnboardingSettings(
    organizationUuid,
    !!organizationUuid
  )
  const {
    hostName,
    port: portData,
    protocol: protocolData
  } = data?.globalOnboardingEndpoint ?? {}

  const protocol = protocolData ? protocolData + '://' : 'https://'
  const port = portData ? ':' + portData : ''
  const destinationUrl = hostName ? `${protocol}${hostName}${port}` : ''

  const handleOptionClick = async (scmType) => {
    await postOnboardingService({
      organizationUuid,
      teamServerUrl: teamserverUrl?.replace('/Contrast', ''),
      destinationUrl,
      scmType
    })
      .then((response) => window.open(response.scmInstallationUrl))
      .catch(() =>
        toast(
          formatMessage({
            id: 'error_addSensorWizard_adding_repository'
          }),
          { variant: 'error' }
        )
      )
  }

  return (
    <FullscreenModal
      isOpen={true}
      HeaderProps={{
        cancelIconTestID: 'cancel-icon',
        headerContainerClassName: headerStyles,
        renderTitle: () => (
          <Stack flexDirection="column" spacing="8px">
            <Text font="titleH1">
              {formatMessage({ id: 'title-scm-options-header' })}
            </Text>
            <Text font="body" color="neutral70">
              {formatMessage({ id: 'body-scm-options-header' })}
            </Text>
          </Stack>
        )
      }}
      onClose={() => window.history.back()}
      testId="scm-options-modal"
    >
      <div className={bodyStyles}>
        <Stack
          flexDirection="column"
          className={css`
            padding: 24px 0px 48px 0px;
          `}
          spacing="0px"
        >
          <Text font="titleH2" color="neutral100">
            {formatMessage({ id: 'title-scm-options-body' })}
          </Text>
          <Text font="body" color="neutral100">
            {formatMessage({ id: 'body-scm-options-body' })}
          </Text>
        </Stack>
        <Stack flexDirection="row" spacing="24px">
          {showBitbucket && (
            <SCMOption
              onClick={handleOptionClick}
              scmType={SCMType.BITBUCKET}
            />
          )}
          <SCMOption scmType={SCMType.GITHUB} onClick={handleOptionClick} />
          {showGitlab && (
            <SCMOption scmType={SCMType.GITLAB} onClick={handleOptionClick} />
          )}
        </Stack>
      </div>
    </FullscreenModal>
  )
}
